import type { Distance, Point } from "@pdfking/math"
import { MM } from "@pdfking/quantity"

import type { FolderCorner } from "#internal"
import type { FolderPath } from "#public"

import { FolderInside } from "./FolderInside"
import { FolderLine } from "./FolderLine"

// How far from the edge of their panel slits stay.
const MARGIN = MM(2)

/** Slits, each from its first point to its second, cut only if every one of
 * them fits inside `region` — a flap, a pocket. */
export const FolderLines = (
  region: FolderCorner[],
  ...lines: [Point<Distance>, Point<Distance>][]
): FolderPath[] => {
  const inside = FolderInside(region, MARGIN)
  return lines.every(([a, b]) => inside(a) && inside(b))
    ? lines.map(([a, b]) => FolderLine(a, b))
    : []
}
